<template>
  <div class="checkout-page">

    <!-- Page header -->
    <div class="page-header">
      <button class="back-btn" onclick="window.history.back()"><i class="ft-arrow-left"></i></button>
      <div class="header-info">
        <span class="page-title">Checkout</span>
        <span class="page-subtitle" v-if="patientName">
          <i class="ft-user"></i> {{ patientName }}
        </span>
      </div>
      <div class="cart-count-badge" v-if="cartCount > 0">
        {{ cartCount }} item{{ cartCount !== 1 ? 's' : '' }}
      </div>
    </div>

    <div class="content-wrap">
      <Cart show-delete="true" show-quantity="true" show-notes="true" show-checkout="false"></Cart>
    </div>

  </div>
</template>

<script>
import Cart from '@/components/navigation/Cart.vue'

export default {
  name: 'checkout',
  components: { Cart },
  computed: {
    patientName: function () {
      try { return JSON.parse(window.localStorage.getItem('bed')).patient_name } catch (e) { return '' }
    },
    cartCount: function () {
      try { return JSON.parse(window.localStorage.getItem('cart')).length } catch (e) { return 0 }
    }
  },
  mounted: function () {
    this.$store.commit('SET_LAYOUT', 'AppLayout')
  }
}
</script>

<style scoped>
.checkout-page {
  min-height: 100vh;
  background: #f0f4f8;
  padding-bottom: 40px;
}

/* ── Page header ── */
.page-header {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 30px 20px 20px;
  background: linear-gradient(135deg, #1a587b 0%, #0f3d5c 100%);
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 10;
  margin-top: 3.2rem;
  border-radius: 0;
  box-shadow: 0 8px 32px rgba(15, 61, 92, 0.35);
}

.back-btn {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  background: #fb5653;
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1rem;
  cursor: pointer;
  flex-shrink: 0;
  transition: background 0.15s;
}
.back-btn:hover { background: #e03e3b; }

.header-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 3px;
  min-width: 0;
}

.page-title {
  font-size: 1.05rem;
  font-weight: 700;
  color: #fff;
}

.page-subtitle {
  font-size: 0.73rem;
  color: rgba(255, 255, 255, 0.65);
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 4px;
}
.page-subtitle i { font-size: 0.65rem; }

.cart-count-badge {
  background: rgba(255, 255, 255, 0.18);
  border: 1px solid rgba(255, 255, 255, 0.25);
  color: #fff;
  font-size: 0.72rem;
  font-weight: 700;
  padding: 4px 10px;
  border-radius: 999px;
  flex-shrink: 0;
  white-space: nowrap;
}

/* ── Content ── */
.content-wrap {
  padding: 110px 16px 0;
  max-width: 680px;
  margin: 0 auto;
}
</style>
